export const ITEM_REALTIME_STATE = {
  WAITING_FOR_MEMBERSHIP: 'waiting_for_membership',
  WAITING_FOR_BROKER_SUBSCRIPTION: 'waiting_for_broker_subscription',
  WAITING_FOR_SUBSCRIPTION: 'waiting_for_subscription',
  SUBSCRIBED_WAITING_FOR_FIRST_TICK: 'subscribed_waiting_for_first_tick',
  LIVE: 'live',
  STALE: 'stale',
  SUBSCRIPTION_FAILED: 'subscription_failed',
  REJECTED: 'rejected',
  REJECTED_EXPIRED: 'rejected_expired',
  REJECTED_INACTIVE: 'rejected_inactive',
  REJECTED_INVALID: 'rejected_invalid',
};

export const resolveBrokerStatusField = (message = {}) => (
  message.brokerStatus
  ?? message.broker_status
  ?? message.status
  ?? null
);

export const mapBrokerStatusToItemState = (brokerStatus, hasTick = false) => {
  if (!brokerStatus) return null;
  const normalized = String(brokerStatus).toLowerCase().trim();

  switch (normalized) {
    case 'subscribed':
    case 'already_subscribed':
    case 'metadata_enriched':
      return hasTick ? ITEM_REALTIME_STATE.LIVE : ITEM_REALTIME_STATE.SUBSCRIBED_WAITING_FOR_FIRST_TICK;
    case 'pending':
    case 'waiting':
      return ITEM_REALTIME_STATE.WAITING_FOR_BROKER_SUBSCRIPTION;
    case 'failed':
    case 'failed_retryable':
    case 'subscription_failed':
      return ITEM_REALTIME_STATE.SUBSCRIPTION_FAILED;
    case 'rejected_expired':
    case 'expired':
      return ITEM_REALTIME_STATE.REJECTED_EXPIRED;
    case 'rejected_inactive':
    case 'inactive':
      return ITEM_REALTIME_STATE.REJECTED_INACTIVE;
    case 'rejected_invalid':
    case 'invalid':
      return ITEM_REALTIME_STATE.REJECTED_INVALID;
    case 'rejected':
      return ITEM_REALTIME_STATE.REJECTED;
    default:
      return null;
  }
};

export const getItemStatusPresentation = (state) => {
  switch (state) {
    case ITEM_REALTIME_STATE.WAITING_FOR_MEMBERSHIP:
    case ITEM_REALTIME_STATE.WAITING_FOR_BROKER_SUBSCRIPTION:
    case ITEM_REALTIME_STATE.WAITING_FOR_SUBSCRIPTION:
      return { label: 'Waiting for subscription', style: 'text-amber-600 bg-amber-50' };
    case ITEM_REALTIME_STATE.SUBSCRIBED_WAITING_FOR_FIRST_TICK:
      return { label: 'Waiting for first tick', style: 'text-blue-600 bg-blue-50' };
    case ITEM_REALTIME_STATE.LIVE:
      return { label: 'Live', style: 'text-green-600 bg-green-50' };
    case ITEM_REALTIME_STATE.STALE:
      return { label: 'Stale', style: 'text-gray-500 bg-gray-100' };
    case ITEM_REALTIME_STATE.SUBSCRIPTION_FAILED:
      return { label: 'Subscription failed', style: 'text-red-600 bg-red-50' };
    case ITEM_REALTIME_STATE.REJECTED:
    case ITEM_REALTIME_STATE.REJECTED_EXPIRED:
      return { label: state === ITEM_REALTIME_STATE.REJECTED ? 'Rejected' : 'Expired', style: 'text-red-600 bg-red-50' };
    case ITEM_REALTIME_STATE.REJECTED_INACTIVE:
      return { label: 'Inactive', style: 'text-red-600 bg-red-50' };
    case ITEM_REALTIME_STATE.REJECTED_INVALID:
      return { label: 'Invalid', style: 'text-red-600 bg-red-50' };
    default:
      return { label: 'Waiting for subscription', style: 'text-amber-600 bg-amber-50' };
  }
};

export const extractBrokerResultsFromMessage = (message) => {
  if (!message || typeof message !== 'object') return [];

  // Standalone broker status notification
  if (
    message.type === 'broker_subscription_result' ||
    message.type === 'subscription_status' ||
    message.type === 'broker_status' ||
    message.type === 'symbol_status'
  ) {
    const token = Number(message.instrument_token ?? message.token);
    if (Number.isSafeInteger(token) && token > 0) {
      return [{
        token,
        requestId: message.requestId ?? message.request_id ?? null,
        status: resolveBrokerStatusField(message),
        message: message.message ?? null,
      }];
    }
  }

  const results = [];
  const rawList = message.results ?? message.statuses ?? message.symbol_statuses ?? [];
  if (Array.isArray(rawList)) {
    rawList.forEach((entry) => {
      const token = Number(entry.instrument_token ?? entry.token);
      if (Number.isSafeInteger(token) && token > 0) {
        results.push({
          token,
          requestId: entry.requestId ?? entry.request_id ?? message.requestId ?? null,
          status: resolveBrokerStatusField(entry) ?? resolveBrokerStatusField(message),
          message: entry.message ?? null,
        });
      }
    });
  }

  const messageStatus = resolveBrokerStatusField(message);
  if (results.length === 0 && messageStatus) {
    const tokens = (message.tokens || message.subscribed || []).map(Number);
    tokens.forEach((token) => {
      if (Number.isSafeInteger(token) && token > 0) {
        results.push({
          token,
          requestId: message.requestId ?? null,
          status: messageStatus,
          message: message.message ?? null,
        });
      }
    });
  }

  return results;
};
